import { Kollections } from '@features/kollections';

export default function KollectionsPage() {
  return <Kollections />;
}
